export const GOLDEN_RATIO = 0.382

/** @returns Array of normalized by scaling factor values */
export const normalize = <T extends number[]>(values: T, scale: number): T =>
  values.map((v) => v / scale) as T

/** Checks if value is in the given range */
export const isInRange = (value: number, min: number, max: number) => value >= min && value <= max

/** Clamps the provided number to the provided bounds
 * @param n - number to clamp
 * @param min - minimum value
 * @param max - maximum value
 */
export const clamp = (
  n: number,
  { min = -Infinity, max = Infinity }: { min?: number; max?: number } = {},
) => Math.min(Math.max(n, min), max)

/** Rounds the provided number to the provided precision
 * @param n - number to round
 * @param precision - number of decimal places
 */
export const round = (n: number, precision: number) => {
  const factor = 10 ** precision

  return Math.round(n * factor) / factor
}

/** @returns x * (1 - a) + y * a */
export const mix = (x: number, y: number, a: number) => x * (1 - a) + y * a

/** @returns Mean value of the passed number array (`sum(arr) / len(arr)`) */
export const mean = (values: number[]) => values.reduce((acc, v) => acc + v, 0) / values.length

/** @returns Midpoint between two points (`{ x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2 }`) */
export const averagePoint = (
  p1: { x: number; y: number },
  p2: { x: number; y: number },
): { x: number; y: number } => ({
  x: (p1.x + p2.x) / 2,
  y: (p1.y + p2.y) / 2,
})
